import React from 'react'
import PropTypes from 'prop-types'
import FloatingActionButton from 'material-ui/FloatingActionButton'
import CircularProgress from 'material-ui/CircularProgress'
import DeliveredIcon from '../../assets/DeliveredIcon'
import styles from '../styles/SubmitMessageButton'

const SubmitMessageButton = ({
  handleSendMessage,
  isSendingBlastMsg,
  isSendingIndivMsg,
  isDisabled,
}) => {
  const buttonBackgroundColor = isDisabled
    ? styles.disabledButtonColor
    : styles.buttonBackgroundColor

  return (
    <FloatingActionButton
      disabled={isDisabled}
      style={styles.sendButton}
      backgroundColor={buttonBackgroundColor}
      onTouchTap={handleSendMessage}
      className="submit-message-button"
    >
      {isSendingBlastMsg || isSendingIndivMsg ? (
        <CircularProgress
          size={0.5}
          style={styles.blastMessageSendingSpinner.outer}
          innerStyle={styles.blastMessageSendingSpinner.inner}
        />
      ) : (
        <DeliveredIcon fill={'white'} styles={styles.sendIcon} />
      )}
    </FloatingActionButton>
  )
}

SubmitMessageButton.propTypes = {
  handleSendMessage: PropTypes.func.isRequired,
  isSendingBlastMsg: PropTypes.bool.isRequired,
  isSendingIndivMsg: PropTypes.bool.isRequired,
  isDisabled: PropTypes.bool.isRequired,
}

export default SubmitMessageButton



// WEBPACK FOOTER //
// ./src/components/Messages/MessagesEditor/SubmitMessageButton.js